import {Injectable} from '@angular/core';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';

@Injectable()
export class LabelkeyService {
  private EOS_PREFIX = 'eos-tv-shop-ii';

  constructor() {
  }

  getSubscribedLabelKey(omapiId: string, isDeepLinking: boolean): string {
    return isDeepLinking ? 'eos-tv-shop-ii.lbl.already-subscribed' : this.EOS_PREFIX + '.lbl.' + this.compileProductLabelKey(omapiId + '') + '-already-subscribed';
  }

  getConditionsModalLabelKey(omapiId: string): string {
    return this.EOS_PREFIX + '.text.' + this.compileProductLabelKey(omapiId) + '-conditions-modal';
  }

  getOrderButtonLabelKey(omapiId: string): string {
    return this.EOS_PREFIX + '.btn.' + this.compileProductLabelKey(omapiId) + '-order';
  }

  getLabelForUpgrade(): string {
    return 'eos-tv-shop-ii.btn.upgrade';
  }

  getOrderButtonLabelKeyWithSubProduct(omapiId: string, subomapiId: string): string {
    return this.EOS_PREFIX + '.btn.' + this.compileProductLabelKey(omapiId) + '-' + this.compileProductLabelKey(subomapiId) + '-order';
  }

  private compileProductLabelKey(omapiId: string): string {
    const productName = this.productName(omapiId);

    return productName.replace(new RegExp(' ', 'g'), '-').toLocaleLowerCase();
  }

  private productName(omapiId: string): string {
    let result = '';
    OmapiIdConstants.PRODUCT_NAME_MAP.forEach((value, key) => {
        if (key === omapiId) {
          result = value;
        }
      }
    );
    if (omapiId === OmapiIdConstants.VOO_FOOT_VLA || omapiId === OmapiIdConstants.VOO_FOOT_BXL_WAL) {
      result = 'VOO Foot';
    }
    return result;
  }

  getOrderSucceededTitleKey(pack?: TvShopEntertainmentPack): string {
    if (pack && pack.isStreamingBundle) {
      return 'eos-tv-shop-ii.title.streaming-bundle-order-succeeded';
    }
    if (pack && pack.isStreamingStandaloneProduct) {
      return 'eos-tv-shop-ii.title.streaming-standalone-product-order-succeeded';
    }

    return 'eos-tv-shop-ii.title.order-succeeded';
  }

  getOrderSucceededDescriptionKey(pack: TvShopEntertainmentPack): string {
    if (pack && pack.isStreamingBundle) {
      return 'eos-tv-shop-ii.text.streaming-bundle';
    }

    if (pack && pack.isStreamingStandaloneProduct) {
      return 'eos-tv-shop-ii.text.streaming-standalone-product'
    }

    if (pack && pack.hasDayPass) {
      return 'eos-tv-shop-ii.text.conversion-from-day-pass-succeeded';
    }

    if (pack && pack.hasTrial && pack.isUpgrade) {
      return 'eos-tv-shop-ii.text.upgrade-from-trial-succeeded';
    }

    if (pack && pack.hasTrial) {
      return 'eos-tv-shop-ii.text.conversion-from-trial-succeeded';
    }

    if (pack && pack.isUpgrade) {
      return 'eos-tv-shop-ii.text.upgrade-succeeded';
    }

    return 'eos-tv-shop-ii.text.order-succeeded';
  }

  getTailerLabelKey(omapiId: string) {
    return 'eos.trailer.' + omapiId;
  }
}
